import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

const VALID_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/tiff',
  'image/gif',
];
export const MEGABYTE = 1000000;
const VALID_FILE_SIZE = 5 * MEGABYTE;
const ERRORS = {
  invalidType: 'Upload an image file, for example .jpeg or .png.',
  tooLarge: 'The image you have uploaded is too large, the file must be no larger than 5MB.',
  noFileSelected: 'No file selected. Please upload an image.',
};

// Actions
export const FILE_IS_VALID = 'EVIDENCE_UPLOAD/FILE_IS_VALID';
export const FILE_INVALID_TYPE = 'EVIDENCE_UPLOAD/FILE_INVALID_TYPE';
export const FILE_TOO_LARGE = 'EVIDENCE_UPLOAD/FILE_TOO_LARGE';
export const ERROR_MESSAGE_CLOSE = 'EVIDENCE_UPLOAD/ERROR_MESSAGE_CLOSE';
export const NO_FILE_SELECTED = 'EVIDENCE_UPLOAD/NO_FILE_SELECTED';

// Action Creators
export const validateFile = (file, locked, event) => {
  if (locked) {
    event.preventDefault();
  }
  if (!file) {
    return {
      type: NO_FILE_SELECTED,
    };
  }
  if (!VALID_FILE_TYPES.includes(file.type)) {
    return {
      type: FILE_INVALID_TYPE,
    };
  }
  if (file.size > VALID_FILE_SIZE) {
    return {
      type: FILE_TOO_LARGE,
    };
  }
  return {
    type: FILE_IS_VALID,
  };
};

export const closeErrorMessage = () => ({
  type: ERROR_MESSAGE_CLOSE,
});

// Selectors
export const getShowError = state => state.showError;
export const getErrorMessage = state => state.errorMessage;
export const getLockNextButton = state => state.lockNextButton;

// Reducers
const showError = handleActions({
  [FILE_IS_VALID]: () => false,
  [FILE_INVALID_TYPE]: () => true,
  [FILE_TOO_LARGE]: () => true,
  [NO_FILE_SELECTED]: () => true,
  [ERROR_MESSAGE_CLOSE]: () => false,
}, false);

const errorMessage = handleActions({
  [FILE_IS_VALID]: () => '',
  [FILE_INVALID_TYPE]: () => ERRORS.invalidType,
  [FILE_TOO_LARGE]: () => ERRORS.tooLarge,
  [NO_FILE_SELECTED]: () => ERRORS.noFileSelected,
}, '');

const lockNextButton = handleActions({
  [FILE_IS_VALID]: () => false,
  [FILE_INVALID_TYPE]: () => true,
  [FILE_TOO_LARGE]: () => true,
  [NO_FILE_SELECTED]: () => true,
}, true);

export default combineReducers({
  showError,
  errorMessage,
  lockNextButton,
});
